const HistoryIcon = ({ className }) => {
	return (
		<svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
			<path
				fill="currentColor"
				d="M111.4,242.8H31c-11.5,0-21-9.6-21-21.7V34.9c0-12.1,9.6-21.7,21-21.7h167.8c11.5,0,21,9.6,21,21.7v67c0,3.8-2.6,6.4-6.4,6.4c-3.8,0-6.4-2.6-6.4-6.4v-67c0-5.1-3.8-8.9-8.3-8.9H31c-4.5,0-8.3,3.8-8.3,8.9v186.9c0,5.1,3.8,8.9,8.3,8.9h80.4c3.8,0,6.4,2.6,6.4,6.4C117.8,240.9,115.2,242.8,111.4,242.8z"
			/>
			<path
				fill="currentColor"
				d="M163.7,80.2H60.4c-3.8,0-6.4-2.6-6.4-6.4c0-3.8,2.6-6.4,6.4-6.4h103.3c3.8,0,6.4,2.6,6.4,6.4C170.1,77.6,167.5,80.2,163.7,80.2z"
			/>
			<path
				fill="currentColor"
				d="M136.9,135H60.4c-3.8,0-6.4-2.6-6.4-6.4c0-3.8,2.6-6.4,6.4-6.4h76.5c3.8,0,6.4,2.6,6.4,6.4C143.3,132.5,140.8,135,136.9,135z"
			/>
			<path
				fill="currentColor"
				d="M107,190.5H60.4c-3.8,0-6.4-2.6-6.4-6.4s2.6-6.4,6.4-6.4H107c3.8,0,6.4,2.6,6.4,6.4S110.8,190.5,107,190.5z"
			/>
			<path
				fill="currentColor"
				d="M189.2,126.7c-31.3,0-56.8,25.5-56.8,56.8s25.5,56.8,56.8,56.8s56.8-25.5,56.8-56.8S221.1,126.7,189.2,126.7z M216.7,188.6h-25.5c-3.8,0-6.4-2.6-6.4-6.4v-35.7c0-3.8,2.6-6.4,6.4-6.4c3.8,0,6.4,2.6,6.4,6.4v29.3h19.1c3.8,0,6.4,2.6,6.4,6.4C223,186,220.5,188.6,216.7,188.6z"
			/>
		</svg>
	);
};

export default HistoryIcon;
